import qs from 'qs';
import { possibleEnvs, possibleLngs, urls, } from '@companyon/constants';
export function isEnv(s) {
    return possibleEnvs.includes(s);
}
export function isLng(s) {
    return possibleLngs.hasOwnProperty(s);
}
export function manifestGeneratorUrl(side, deviceIds, bearerTokens, lng) {
    var _a;
    let ids = {};
    // bearerTokens retains some outdated secrets on purpose;
    // we should not save them, as it will probably result in
    // plenty of error messages on startup.
    for (const id of deviceIds) {
        if (bearerTokens.hasOwnProperty(id)) {
            ids[id] = bearerTokens[id];
        }
        else {
            ids[id] = '';
        }
    }
    const rae = (_a = process.env.REACT_APP_ENV) !== null && _a !== void 0 ? _a : 'development';
    const env = isEnv(rae) ? rae : 'development';
    return (urls.api.http[env] +
        '/manifestGenerator?' +
        qs.stringify({ ids, env, side, lng }));
}
//# sourceMappingURL=manifestGeneratorUrl.js.map